// firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getDatabase } from "firebase/database"; 
const firebaseConfig = {

  apiKey: "AIzaSyALQb94q5YrsaxayizIIvo3HOXFFpC3ZV4",

  authDomain: "vikpq-b3300.firebaseapp.com",

  projectId: "vikpq-b3300",

  storageBucket: "vikpq-b3300.firebasestorage.app",

  messagingSenderId: "138117491586",

  appId: "1:138117491586:web:028b326f708106383a3d9b",

  measurementId: "G-C155DT4CTV"

};








// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getDatabase(app); 

// Export the initialized Firebase app
export { app, db };
